import React, { useState } from "react";
import { createTransaction, fetchTransactions } from "@services/api";

import { useAppStore } from "@store/appStateStore";
import ParticipantInput from "../control/participant/select/participantInput";
import { sortParticipantsByName } from "../utils/sort";

const AddTransactionForm: React.FC = () => {
  const { participants, setTransactions } = useAppStore();

  const [participant_id, setParticipantId] = useState<number>(0);
  const [amount, setAmount] = useState<number>(0);
  const [date, setDate] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const handleSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();

    if (participant_id === 0 || amount === 0 || !date || !type) {
      alert("Заполните форму");
      return;
    }

    try {
      await createTransaction({
        participant_id,
        amount,
        date,
        type,
        description,
      });

      const transactions = await fetchTransactions();
      setTransactions(transactions);

      // Сброс формы
      setParticipantId(0);
      setAmount(0);
      setDate("");
      setType("");
      setDescription("");
    } catch (error) {
      console.error("Ошибка при добавлении транзакции:", error);
      alert("Не удалось добавить транзакцию");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="participant_id" className="control">
          Участник:
        </label>
        <ParticipantInput
          id="participantSelect"
          value={participant_id}
          onChange={setParticipantId}
          required={true}
          options={sortParticipantsByName(participants)}
        />
      </div>

      <div>
        <label htmlFor="amount" className="control">
          Сумма:
        </label>
        <input
          id="amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value))}
          placeholder="Введите сумму"
          required
          className="control"
        />
      </div>

      <div>
        <label htmlFor="date" className="control">
          Дата:
        </label>
        <input
          id="date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
          className="control"
        />
      </div>

      <div>
        <label htmlFor="type" className="control">
          Тип:
        </label>
        <input
          id="type"
          type="text"
          value={type}
          onChange={(e) => setType(e.target.value)}
          placeholder="Введите тип транзакции"
          required
          className="control"
        />
      </div>

      <div style={{ paddingBottom: "1rem" }}>
        <label htmlFor="description" className="control">
          Описание:
        </label>
        <textarea
          style={{ maxWidth: "100%", minHeight: "50px" }}
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Введите описание"
          className="control"
        />
      </div>

      <button type="submit" className="control">
        Добавить транзакцию
      </button>
    </form>
  );
};

export default AddTransactionForm;
